// Dunne wrappers rond /api/*. Cookies meesturen voor de player_id.

const COMMON = {
  credentials: 'include',
  headers: { 'Content-Type': 'application/json' },
}

async function jsonOrThrow(res) {
  if (!res.ok) {
    let msg = `HTTP ${res.status}`
    try { const err = await res.json(); if (err?.error) msg = err.error } catch {}
    throw new Error(msg)
  }
  return res.json()
}

export async function getHealth() {
  const res = await fetch('/api/health', { ...COMMON, method: 'GET' })
  return jsonOrThrow(res)
}

// /api/generate: vraag de server een volledige of uitbreidings-entry te genereren.
export async function generateEntry(node, opts = {}) {
  const body = { node }
  if (opts.mode) body.mode = opts.mode
  if (opts.existingSections) body.existingSections = opts.existingSections
  const res = await fetch('/api/generate', {
    ...COMMON,
    method: 'POST',
    body: JSON.stringify(body),
  })
  return jsonOrThrow(res) // { sections, model, cached, mode }
}

// Wikipedia: samenvatting, volledig artikel, of alleen thumbnail.
export async function getWikipedia(title, lang = 'en') {
  const p = new URLSearchParams({ title, lang })
  return jsonOrThrow(await fetch(`/api/wikipedia?${p}`, { ...COMMON, method: 'GET' }))
}
export async function getWikipediaFull(title, lang = 'en') {
  const p = new URLSearchParams({ title, lang })
  return jsonOrThrow(await fetch(`/api/wikipedia/full?${p}`, { ...COMMON, method: 'GET' }))
}
export async function getWikipediaImage(title, lang = 'en') {
  const p = new URLSearchParams({ title, lang })
  return jsonOrThrow(await fetch(`/api/wikipedia/image?${p}`, { ...COMMON, method: 'GET' }))
}

export async function searchWikipediaImage(name) {
  const p = new URLSearchParams({ name })
  return jsonOrThrow(await fetch(`/api/wikipedia/search-image?${p}`, { ...COMMON, method: 'GET' }))
}

// Wikipedia langlinks: ontdek de titel in een andere taal.
export async function getWikipediaLanglinks(title, lang, target) {
  const p = new URLSearchParams({ title, lang, target })
  return jsonOrThrow(await fetch(`/api/wikipedia/langlinks?${p}`, { ...COMMON, method: 'GET' }))
}

// /api/discover: AI-suggesties op basis van kaartgebied.
export async function discoverPlaces(lat, lng, radiusKm = 20) {
  const res = await fetch('/api/discover', {
    ...COMMON,
    method: 'POST',
    body: JSON.stringify({ lat, lng, radiusKm }),
  })
  return jsonOrThrow(res) // { places, cached }
}

// State (cookie-player_id).
export async function getState() {
  const res = await fetch('/api/state', { ...COMMON, method: 'GET' })
  return jsonOrThrow(res)
}
export async function setState(patch) {
  const res = await fetch('/api/state', {
    ...COMMON,
    method: 'POST',
    body: JSON.stringify(patch),
  })
  return jsonOrThrow(res)
}
